module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('News')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _vm._l((_vm.news), function(article, index) {
    return _c('news-article', {
      key: article._id,
      attrs: {
        "article": article,
        "no-separator": index === _vm.news.length - 1
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12fab740","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 935
// module chunks = 0